import { Decimal } from 'decimal.js';
import { Maths } from 'helpers/maths';

export default function convertTwoPlaces(number) {
  return Maths.parseFloatRound(number, 2, Decimal.ROUND_HALF_UP);
}
